import { createFileRoute } from "@tanstack/react-router";
import AdminResourceNewPage from "@/pages/admin/lms/resources/new";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/resources/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllMaterials, userCanViewAllMaterials } = useLmsPermissions();

  return (
    <AdminResourceNewPage
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
    />
  );
}
